/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {openReportCashboxesCounter} from '../../common/menu/report/cashboxes/actions';
import CashboxesPanel from '../menu/report/cashboxes/CashboxesPanel';
import {logout} from '../../common/login/actions';
import {openMessage} from '../../common/components/messages/actions';
import {closeBarReport} from '../../common/report/actions';

class ReportCashboxesCounter extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        openReportCashboxesCounter: React.PropTypes.func,
        waitingOrders: React.PropTypes.object,
        showCloseReportButton: React.PropTypes.bool,
        openMessage: React.PropTypes.func,
        closeBarReport: React.PropTypes.func,
        logout: React.PropTypes.func,
        deviceId: React.PropTypes.number
    };

    constructor(props) {
        super(props);

        this.closeBarReport = this.closeBarReport.bind(this);
    }

    closeBarReport() {
        const {
            closeBarReport, bar, logout, openMessage, openReportCashboxesCounter, deviceId, waitingOrders, msg
        } = this.props;
        openReportCashboxesCounter(false);

        closeBarReport(bar.get('id')).payload.promise
            .then(() => {
                logout(deviceId);
            })
            .catch(res => {
                if (!res.status) {
                    if (!!waitingOrders && waitingOrders.size > 0) {
                        openMessage(msg.menu.message.deviceOffline, `${msg.closeReport.unableCloseReport} ${msg.closeReport.notSentBills} ${waitingOrders.size}. ${msg.closeReport.billSendLater}`);
                    } else {
                        openMessage(msg.menu.message.deviceOffline, `${msg.closeReport.unableCloseReport}`);
                    }
                    logout(deviceId);
                }
            });
    }

    render() {
        const {openReportCashboxesCounter, showCloseReportButton, msg} = this.props;

        return (
            <div id="menu" className="pageMenu">
                <div className="pageMenu-panel">
                    <CashboxesPanel />
                </div>
                {!showCloseReportButton &&
                <div className="pageMenu-controls">
                  <div className="pageMenu-controls-key"></div>
                  <div className="pageMenu-controls-key">
                    <div className="boxBtn text-l color-green">
                        <div className="boxBtn-inner" onClick={() => openReportCashboxesCounter(false)}>
                            <span>{msg.closeReport.continue}</span>
                        </div>
                    </div>
                  </div>
                  <div className="pageMenu-controls-key">
                  </div>
                </div>
                }
                {!!showCloseReportButton &&
                <div className="pageMenu-controls">
                  <div className="pageMenu-controls-key"></div>
                  <div className="pageMenu-controls-key view-half">
                    <div className="boxBtn text-l color-red">
                        <div className="boxBtn-inner" onClick={() => openReportCashboxesCounter(false)}>
                            <span>{msg.global.back}</span>
                        </div>
                    </div>
                  </div>
                  <div className="pageMenu-controls-key view-half">
                    <div className="boxBtn text-l color-green">
                        <div className="boxBtn-inner" onClick={() => this.closeBarReport()}>
                            <span>{msg.closeReport.closeReport}</span>
                        </div>
                    </div>
                  </div>
                  <div className="pageMenu-controls-key"></div>
                </div>
                }
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    bar: state.bars.get('bar'),
    showCloseReportButton: state.barReportCashboxes.get('showCloseReportButton'),
    deviceId: state.device.get('id'),
    waitingOrders: state.categories.get('waitingOrders')
}), {openReportCashboxesCounter, logout, closeBarReport, openMessage})(ReportCashboxesCounter);



// WEBPACK FOOTER //
// ./src/browser/report/ReportCashboxesCounter.js